import { TreeItemsWithMeta } from '@dealstack/frontend/app/pages/Project/DocumentLibrary/utils';
import { SearchSelectWithNestedCollapsableChildrenOptions } from '@dealstack/frontend/shared/components/forms/SearchSelectWithNestedCollapsableChildren/SearchSelectWithNestedCollapsableChildren.types';

// Transform treeItems to proper nested structure for SearchSelectWithNestedCollapsableChildren
export const convertTreeItemsToNestedOptions = (
	items: TreeItemsWithMeta[] = []
): SearchSelectWithNestedCollapsableChildrenOptions[] => {
	return items.map((item) => {
		const option: SearchSelectWithNestedCollapsableChildrenOptions = {
			value: item.dealClassifierId ?? '',
			label: item.name,
		};

		// If the item has children, recursively convert them
		if (item.children && item.children.length > 0) {
			option.children = convertTreeItemsToNestedOptions(item.children);
		}

		return option;
	});
};
